import React, {useState, useEffect} from 'react';
import {StyledUnreconciledModal} from "./Styles/UnreconciledModal.styles.react";
import useFetch from "../../../Utilities/API/useFetch.react";
import {Button, Table} from "react-materialize";
import UnreconciledTransaction from "./UnreconciledTransaction.react";
import SelectedUnreconciledTransaction from "./SelectedUnreconciledTransaction.react";
import {dateFormatter} from "../../../Utilities/utilities";



const UnreconciledModal = ({show, handleClose, transaction}) => {
  const [loading, setLoading] = useState(true);
  const [selectedTransactions, setSelectedTransactions] = useState(null);
  const [transactionList, setTransactionList] = useState([]);

  const [fetchUrl] = useFetch();

  const fetchTransactionEntries = async () => {
    const {transactionID, counterParty} = transaction;
    let transactions = await fetchUrl('fetchUnreconciledTransactionEntries', {id: transactionID, counterParty: counterParty});
    setTransactionList(transactions)
  }

  useEffect( () => {
    if (show === true && transaction!== null) {
      fetchTransactionEntries()
    }
  }, [show, transaction])

  const updateSelectedTransactions = (selected, journalEntry) => {
    if (selected === true && selectedTransactions == null) {
      let transactionsMap = new Map();
      transactionsMap.set(journalEntry.transactionID, journalEntry);
      setSelectedTransactions(transactionsMap);
    } else if (selected === true) {
      let transactionsMap = new Map(selectedTransactions);
      transactionsMap.set(journalEntry.transactionID, journalEntry);
      setSelectedTransactions(transactionsMap);
    } else {
      let transactionsMap = new Map(selectedTransactions);
      transactionsMap.delete(journalEntry.transactionID);
      setSelectedTransactions(transactionsMap);
    }
  }

  let selectedTransactionsArr = selectedTransactions != null ? Array.from(selectedTransactions.entries()) : [];

  return (
    <StyledUnreconciledModal
      open={show}
      options={{onCloseEnd: () => handleClose()}}
      actions={[]}
    >
      <div className={'header'}>
        <div className={'top-half'}>
          <p>{transaction?.type} - {transaction?.sent.quantity} {transaction?.sent.asset.code} to {transaction?.counterParty}</p>
          <p>
            Journal Entries
          </p>
        </div>

        <div className={'bottom-half'}>
          <div className={'date'}>
            <span className={'pill'}>{transaction?.source}</span>
            <div className={'date'}>{dateFormatter(transaction?.date)}</div>
          </div>
          <p>Unreconciled ({transactionList.length})</p>
        </div>
      </div>

      <div className={'modal-content'}>
        <div className={'selected-transactions'}>
          {
            selectedTransactionsArr.length > 0 &&
              selectedTransactionsArr.map((selectedTransaction) => {
                return (
                  <SelectedUnreconciledTransaction transaction={selectedTransaction[1]} handleDelete={updateSelectedTransactions} />
                )
              })
          }
          <div className={'selected-total'}>
            <div>Total Transactions Selected {selectedTransactionsArr.length}</div>
            <Button>Reconcile</Button>
          </div>
        </div>
        <div className={'table-container'}>
          <Table striped>
            <thead>
              <tr>
                <div></div>
                <th data-field='date'>Date</th>
                <th data-field='type'>Type</th>
                <th data-field='sent-quantity'>Sent Quantity</th>
                <th data-field='received-quantity'>Received Quantity</th>
                <th>Fee</th>
                <th data-field='source'>Source</th>
                <th data-field='transaction-id'>Transaction ID</th>
                <th data-field='Counterparty'>Counterparty</th>
              </tr>
            </thead>
            <tbody>
              {
                transactionList.length > 0 &&
                  transactionList.map((journalEntry, index) => {
                    return (
                      <UnreconciledTransaction selectedTransactions={selectedTransactions} journalEntry={journalEntry} index={index} handleCheck={updateSelectedTransactions} />
                    )
                  })
              }
            </tbody>
          </Table>
        </div>
      </div>
    </StyledUnreconciledModal>
  )
}

export default UnreconciledModal;